import { ParentBusiness, SystemBusiness, CommonService, FCCONFIG } from 'fccore2';
import { Fcgrand } from './fcgrand';
import { FCEVENT } from './fc';
import { FcEvent } from './business/fcevent.event';
export abstract class Fclist extends Fcgrand {
  /**
   * æ ¹æ®æ¨¡ååäº§åidåå§åç¶ç±»,å½æ­¤ç±»ä¸å·æmidï¼åæ¨¡åidçæ¶åï¼å¯ä»¥ä¸ä¼ 
   * @param pid äº§åid
   * @param aid æ¨¡åid
   */
  constructor(stateName: string, EVENT: any, mId?: string, aId?: string) {
    /** ç¶ç±»çåå§å */
    super(stateName, EVENT, mId, aId);
  }
  /**
   * å­ç±»æ°æ®åå§å
   */
  initChildData(): any {
    return {
      /** é»è®¤å¯ç¨èªå¨æ¥è¯¢ */
      enableAutoSearch: false,
      /** æ¡ä»¶åå®¹,å­ç¬¦ä¸²ï¼å¿é¡»ç¬¦åjsonæ ¼å¼çå­ç¬¦ä¸²ï¼å½æ­¤å­ç¬¦ä¸²çå¼åçååçæ¶åï¼èªå¨å·æ°åè¡¨ã */
      condition: '',
      /** æ¥è¯¢æ¡ä»¶å¯¹è±¡åå®¹ï¼ææçæ¥è¯¢æ¡ä»¶ç»å®å¨æ­¤å¯¹è±¡ä¸­ã */
      searchObj: {},
      /** é»è®¤çæåºå­æ®µ */
      orderBy: '',
      /** åé¡µæ»æ° */
      pageTotal: 0,
      /** åé¡µç´¢å¼ */
      pageNum: 1,
      /** åé¡µå¤§å° */
      pageSize: 50,
      /** æ°æ®åå®¹ */
     };
  }
  /**
   * å­ç±»åå§åä¼ å¼
   */
  abstract init(): any;
  /**
   * åå§åå½åå¯¹è±¡åå®¹
   */
  ngOnInit() {
    /** æ§è¡æ¥è¯¢äºä»¶ */
    this.init();
    this.search();
  }
  /**
   * èªå®ä¹äºä»¶åç§°ï¼ææèªå®ä¹äºä»¶çå¥å£
   * @param eventName äºä»¶åç§°
   * @param param åæ°
   * overload
   */
  public event(eventName: string, param?: any): void {
    if (this.EVENT[eventName]) {
      SystemBusiness.store.dispatch(this.EVENT[eventName].func(param));
    } else if (this[eventName]) {
      this[eventName](param);
    }
    this.fcEvent.emit({
        eventName,
        param
    });
  }
  /**
   * å­ç±»é»è®¤è°ç¨å¯¹è±¡
   */
  private query(): void {
    const condition: any = {};
    if (this.data.condition && this.data.condition.length > 2) {
      condition.WHERE = this.data.condition;
    }
    condition.PAGESIZE = this.data.pageSize;
    condition.PAGENUM = this.data.pageNum;
    condition.ORDER = this.data.orderBy || this.data.order || '';
    this.data.condition = condition;
    // ç¼å­æ¥è¯¢æ¡ä»¶
    // CacheService.set(this.moduleId + this.appId + 'SEARCHOBJ', this.searchObj);
    if (this.data.enableAutoSearch) {
      this.pushDestroy(
        ParentBusiness.appService
          .findWithQuery(this.data.appId, condition)
          .subscribe(result => {
            if (result.CODE === '0') {
              this.data.pageList = result.DATA;
              this.data.pageTotal = result.TOTALSIZE;
            }
          })
      );
    }
  }
  /**
   * æ¥è¯¢éç½®
   */
  public reset(value) {
    /** å­ç±»æ¥è¯¢æ¡ä»¶åå§å */
    if (this.data.searchObj && Object.keys(this.data.searchObj).length > 0) {
      Object.keys(this.data.searchObj).forEach(key => {
        this.data.searchObj[key] = '';
      });
    }
    this.search();
  }
  /**
   * æ¥è¯¢æ¡ä»¶ååçæ¶åè°ç¨
   */
  public searchObjModelChange(key, value): void {
    if (key) {
      const obj: any = {};
      obj[key] = value || '';
      this.search({ eventName: 'search', param: obj });
    } else {
      this.search();
    }
  }
  /**
   * è·åæ¥è¯¢æ¡ä»¶åå®¹
   * @param event äºä»¶åç§°
   */
  public search(event?: FCEVENT): any {
    if (event) {
      this.data.searchObj = Object.assign(this.data.searchObj, event.param);
    }
    const condition: any = {};
    /** å¤æ­æ¯å¦å­å¨æ¥è¯¢æ¡ä»¶åå®¹ */
    if (typeof this.data.searchObj === 'object') {
      Object.keys(this.data.searchObj).forEach(key => {
        if (this.data.searchObj[key] && this.data.searchObj[key] !== '') {
          if (this.data.searchObj[key] instanceof Array) {
            condition[key] = {between: this.data.searchObj[key] };
          } else {
            condition[key] = {like: '%' + this.data.searchObj[key] + '%' };
          }
        }
      });
    }
    /**   è·åé»è®¤æ¥è¯¢æ¡ä»¶æèªå®ä¹çæ¥è¯¢likeç­ */
    const defautlSearchObj = Object.assign(this.getDefaultQuery(), condition);
    this.data.condition = JSON.stringify(defautlSearchObj);
    this.query();
  }
  /**
   * é»è®¤æ¥è¯¢äºä»¶
   */
  getDefaultQuery(): any {
    return {};
  }
  /**
   * åé¡µäºä»¶ äºä»¶åç§°ï¼param
   * @param event äºä»¶å¯¹è±¡
   */
  pageQuery(event: FCEVENT): void {
    switch (event.eventName) {
      case 'pageSizeChange' /** æ¯é¡µæ¾ç¤ºå¤å°æ¡ */:
        this.data.pageSize = event.param;
        this.data.pageNum = 1;
        break;
      case 'jumpPage' /** è·³è½¬å°ç¬¬å é¡µ */:
        this.data.pageNum = event.param;
        break;
    }
    this.query();
  }
  /**
   * æ¥è¯¢äºä»¶å¤ç
   * @param event æ¥è¯¢äºä»¶åæ°
   */
  searchlistEvent(event: FCEVENT): void {
    switch (event.eventName) {
      case 'search':
        this.search();
        break;
      default:
        this.event(event.eventName, event.param);
    }
  }
  /**
   * æ ¹æ®åè¡¨å¤çäºä»¶
   * @param action äºä»¶åç§°
   */
  listdataEvent(event: FCEVENT) {
    switch (event.eventName) {
      case 'listOneEdit':
        this.listOneEdit(event);
        break;
      case 'listOneDelete':
        this.listOneDelete(event);
        break;
      case 'cellClick':
        this.cellClick(event);
        break;
      case 'rowClick':
        break;
      case 'selected':
        this.onSelect(event);
        break;
      case 'modify':
        this.onModify(event);
        break;
      case 'pageSizeChange':
        this.pageSizeChange(event);
        break;
      case 'jumpPage':
        this.jumpPage(event);
        break;
      default:
        this.event(event.eventName, event.param);
    }
  }
 /**
  * ååæ ¼éä¸­
  * @param event  äºä»¶
  */
  cellClick(event: FCEVENT) {
    if (event.param.field.INPUTTYPE && event.param.field.INPUTTYPE === 'url') {
      // window.open(event.param.data[event.param.field.FIELDCODE], '_blank');
    }
  }
  /**
   * é¡µé¢sizeæ¹å
   * @param event äºä»¶
   */
  pageSizeChange(event: FCEVENT): void {
    this.data.pageSize = event.param;
    if (this.data.enableAutoSearch) {
      this.query();
    }
  }
  /**
   * è·³è½¬è³é¡µé¢
   * @param event äºä»¶
   */
  jumpPage(event: FCEVENT): void {
    this.data.pageNum = event.param;
    if (this.data.enableAutoSearch) {
      this.query();
    }
  }
  /**
   * éä¸­çæ°æ®å¯¹è±¡ååé
   * @param event äºä»¶
   */
  onSelect(event: FCEVENT) {
    this.data.selectedObjects = event.param;
    if (this.data.selectedObjects.length > 0) {
      this.data.selectedObject = this.data.selectedObjects[0];
    }
  }

  /**
   * å¨åè¡¨ä¸­ç¼è¾æ°æ®å¯¹è±¡æ¾å¥ç¼è¾å¯¹è±¡ä¸­
   * @param event äºä»¶
   */
  onModify(event: FCEVENT) {
    this.data.modifyObjs.push(event.param);
  }


  /**
   * åè¡¨æ°å¢
   * @param event äºä»¶
   */
  public listAdd(event?: FCEVENT): void {
  }

  /**
   * åè¡¨ç¼è¾
   * @param event äºä»¶
   */
  public listEdit(event: FCEVENT): void {
    if (this.data.selectedObjects && this.data.selectedObjects.length === 1) {
      if (this.beforeEdit()) {
      }
    } else {
      ParentBusiness.msgService.warm('è¯·éæ©ä¸æ¡è®°å½ï¼');
      return;
    }
  }

  /**
   * åè¡¨ç¼è¾
   * @param event äºä»¶
   */
  public listOneEdit(event: FCEVENT): void {
    if (this.beforeEdit()) {
    }
  }

  /**
   * ç¼è¾ä¹åçæä½
   */
  beforeEdit(): boolean {
    return true;
  }

  /**
   * å é¤ä¸æ¡è®°å½
   * @param context äºä»¶
   */
  listOneDelete(event: any): void {
    CommonService.event(FcEvent.fcmodal.confirm, {
      title: 'ç¡®è®¤å é¤è®°å½åï¼',
      okFunc: () => {
        const mainObj = event.param;
        if (this.beforeDelete(mainObj)) {
          this.pushDestroy(
            ParentBusiness.appService
              .deleteObject(this.data.mainApp.APPID, mainObj.ID)
              .subscribe(result => {
                if (result.CODE === '0') {
                  this.afterDelete();
                  ParentBusiness.msgService.message('å é¤æåï¼');
                  /** this.listWnd.deleteRowDataById([mainObj.ID]); */
                  this.search();
                } else {
                  ParentBusiness.msgService.message('å é¤å¤±è´¥ï¼');
                }
              })
          );
        }
      },
      cancelFunc: () => {}
    });
  }
  /**
   * å é¤ä¹åçæä½
   * @param mainObj å¯¹è±¡
   */
  beforeDelete(mainObj: any): boolean {
    return true;
  }

  /**
   * å é¤ä¹åçæä½
   */
  afterDelete(): void {}
  /**
   * åè¡¨æ¹éå é¤
   * @param event äºä»¶
   */
  listDelete(event: FCEVENT): void {
    if (this.data.selectedObjects.length === 0) {
      ParentBusiness.msgService.warm('è¯·éæ©è³å°ä¸æ¡è®°å½ï¼');
      return;
    }
    let canDo = true;
    this.data.selectedObjects.forEach(mainObj => {
      if (!this.beforeDelete(mainObj)) {
        canDo = false;
      }
    });
    if (!canDo) {
      return;
    }
    const ids = [];
    this.data.selectedObjects.forEach(obj => {
      ids.push({ ID: obj.ID });
    });
    CommonService.event(FcEvent.fcmodal.confirm, {
      title: 'ç¡®è®¤å é¤è®°å½åï¼',
      okFunc: () => {
        this.pushDestroy(
          ParentBusiness.appService
            .deleteObjects(this.data.mainApp.APPID, ids)
            .subscribe(result => {
              if (result.CODE === '0') {
                this.afterDelete();
                this.data.selectedObjects.forEach(obj => {
                  /** this.listWnd.deleteRowDataById([obj.ID]); */
                });
                ParentBusiness.msgService.message('å é¤æåï¼');
              } else {
                ParentBusiness.msgService.message('å é¤å¤±è´¥ï¼');
              }
            })
        );
      },
      cancelFunc: () => {}
    });
  }

  /**
   * åè¡¨å¸®å©
   * @param action äºä»¶
   */
  listHelp(action: string): void {}

  /**
   * åè¡¨å¯¼å¥
   * @param action äºä»¶
   */
  import(action: string): void {}

  /**
   * åè¡¨å¯¼åº
   * @param action  äºä»¶
   */
  export(action: string): void {
    const selectObjs = this.data.selectedObjects;
    let where;
    if (selectObjs && selectObjs.length > 0) {
      where = 'AND ID in (';
      selectObjs.forEach(obj => {
        where += '\'' + obj.ID + '\',';
      });
      where += '\'\')';
    }
    if (where === undefined) {
      window.open(FCCONFIG.apiurl + this.data.mId + '/SYSRESLIB/EXPORTEXCEL');
    } else {
      window.open(
        FCCONFIG.apiurl +
          this.data.mId +
          '/SYSRESLIB/EXPORTEXCEL?WHERE=' +
          encodeURIComponent(where)
      );
    }
    //      this.mainService.providers.daoService.getFromApi(this.mainService
    //   let a = result;
    //      });
    //     // å¦ææ²¡æéä¸­æ°æ®ï¼ä»åç«¯ååºå¯¼åºæ°æ®
    //     let datas: any[] = this.mainService.commonService.cloneArray(thi
    //     let data: any[] = [];
    //     /let header: string[] = [];
    //     this.mainFields.forEach(field => {
    //     header.push(field.FIELDNAME);
    //     });
    //     data.push(header);
    // //    å¦æéä¸­æ°æ®ï¼å¯¼åºå·²éä¸­çæ°æ®
    //     if (select.length !== 0) datas = select;
    //      datas.forEach(row => {
    //       let obj: any[] = [];
    //         this.mainFields.forEach(field => {
    //            if (row[field.FIELDCODE + '_DICDESC']) {
    //                obj.push(row[field.FIELDCODE + '_DICDESC']);
    //            } else {
    //               obj.push(row[field.FIELDCODE]);*/
    //            }
    //         });
    //       data.push(obj);
    //    })*/
    //      generate worksheet */
    //     const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(data);
    //     generate workbook and add the worksheet
    //      const wb: XLSX.WorkBook = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(wb, ws, this.mainApp.APPNAME);
    //     save to file
    //     XLSX.writeFile(wb, this.mainApp.APPNAME + this.mainService.commo
  }

  /**
   * åè¡¨å·¥å·æ å¤çäºä»¶
   * @param event äºä»¶åç§°
   */
  tlblistEvent(event: FCEVENT) {
    switch (event.eventName) {
      case 'listAdd':
        this.listAdd(event);
        break;
      case 'listDelete':
        this.listDelete(event);
        break;
      case 'listEdit':
        this.listEdit(event);
        break;
      case 'listHelp':
        this.listHelp(event.eventName);
        break;
      case 'importexcel':
        this.import(event.eventName);
        break;
      case 'exportexcel':
        this.export(event.eventName);
        break;
      default:
        this.event(event.eventName, event);
    }
  }
}
